import { connect } from 'react-redux'
// import { DndProvider } from 'react-dnd'
// import {HTML5Backend} from 'react-dnd-html5-backend'
import { compose } from 'redux'
import { reorderProgramItem, moviesUpdateOrderRequest } from '../../../actions'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram'
import hasMovies from '../../../hoc/hasMovies'
import toJS from '../../../hoc/toJS'
import PageSortingMoviesPage from '../present/PageSortingMoviesPage';
import hasSelections from '../../../hoc/hasSelections';
import hasCollections from '../../../hoc/hasCollections';

const mapDispatchToProps = (dispatch, ownProps) => ({
    onReorderProgramItem: (dragIndex, hoverIndex) => {
        dispatch(moviesUpdateOrderRequest(dragIndex, hoverIndex))
    },

    onEndReorderProgramItem: () => {
        dispatch(reorderProgramItem())
    }
})

const PageSortingMovies = ({programStatus, programError,  items, order, goBackPath, match, onReorderProgramItem, onEndReorderProgramItem, onUpdateProgram }) => (
    // <DndProvider backend={HTML5Backend}>
        <PageSortingMoviesPage
            programStatus={programStatus}
            programError={programError}
            items={items}
            order={order}
            goBackPath={goBackPath}
            params={match.params}
            onReorderProgramItem={onReorderProgramItem}
            onEndReorderProgramItem={onEndReorderProgramItem}
            onUpdateProgram={onUpdateProgram}
        />      
    // </DndProvider>
)

export default compose(
    hasUpdateProgram(),
    hasSelections(),
    hasCollections(),
    hasMovies(),
    toJS(),
    connect(null, mapDispatchToProps),
    
)(PageSortingMovies)

